<template>
  <div>
    <div v-if="!result">
      <a-card style="margin-top: 24px" :bordered="false" title="法人基本信息">
        <span style="color:red;position: absolute;top: 18px;left: 120px;font-weight: bold">(请根据”首页——办事指南——《福州市电子招投标交易系统注册指南》“要求填写信息)</span>
        <div style="width: 70px;position: absolute;top: 13px;right: 20px;" v-show="editButtonShow">
          <a-button v-has="'enterpriseInfo:edit'" type="primary" @click="ebidEnterprise">编辑</a-button>
        </div>
        <detail-list>
          <detail-list-item term="法人名称">{{ enterprise.legalName }}</detail-list-item>
          <detail-list-item term="组织机构代码">{{ enterprise.organNo }}</detail-list-item>
          <detail-list-item term="组织机构代码证失效日期">{{ enterprise.organCertEndDate }}</detail-list-item>
        </detail-list>
        <detail-list>
          <detail-list-item term="主体类型">{{ enterprise.legalRole_dictText }}</detail-list-item>
          <detail-list-item term="基本户账号">{{ enterprise.basicAccountNo }}</detail-list-item>
          <detail-list-item term="基本户账户名称">{{ enterprise.basicAccountName }}</detail-list-item>
        </detail-list>
        <detail-list>
          <detail-list-item term="法定代表人姓名">{{ enterprise.legalRepresent }}</detail-list-item>
          <detail-list-item term="法定代表人身份证">{{ enterprise.legalIdentityNum }}</detail-list-item>
          <detail-list-item term="法人代表联系电话">{{ enterprise.representPhone }}</detail-list-item>
        </detail-list>
        <detail-list>
          <detail-list-item term="法人机构类别">{{ enterprise.legalType_dictText }}</detail-list-item>
          <detail-list-item term="法人机构地址">{{ enterprise.legalUnitAddress }}</detail-list-item>
          <detail-list-item term="法人业务状态">{{ enterprise.legalStatus_dictText }}</detail-list-item>
        </detail-list>
        <detail-list>
          <detail-list-item term="资信等级">{{ enterprise.creditRate }}</detail-list-item>
          <detail-list-item term="国别/地区">{{ enterprise.countryRegion_dictText }}</detail-list-item>
          <detail-list-item term="行政区域代码">{{ enterprise.regionCode }}</detail-list-item>
        </detail-list>
        <detail-list>
          <detail-list-item term="注册地">{{ enterprise.registerProvince }}/{{ enterprise.registerCity }}/{{enterprise.registerRegion}}</detail-list-item>
          <detail-list-item term="详细地址">{{ enterprise.registerAddress }}</detail-list-item>
          <detail-list-item term="基本户开户银行">{{ enterprise.basicBank }}</detail-list-item>
        </detail-list>
        <detail-list>
          <detail-list-item term="基本户开户支行号">{{ enterprise.basicBranchBank }}</detail-list-item>
          <detail-list-item term="法人类别">{{ enterprise.bidderCodeType_dictText }}</detail-list-item>
          <detail-list-item term="法人代码">{{ enterprise.legalCode }}</detail-list-item>
        </detail-list>
        <detail-list>
          <detail-list-item term="注册资本">{{ enterprise.regCapital }}</detail-list-item>
          <detail-list-item term="注册资本币种">{{ enterprise.regCapCurrency_dictText }}</detail-list-item>
          <detail-list-item term="注册资本单位">{{ enterprise.regUnit_dictText }}</detail-list-item>
        </detail-list>
        <detail-list>
          <detail-list-item term="联系人">{{ enterprise.legalContact }}</detail-list-item>
          <detail-list-item term="联系人电话">{{ enterprise.legalContactPhone }}</detail-list-item>
          <detail-list-item term="联系人地址">{{ enterprise.legalContactAddress }}</detail-list-item>
        </detail-list>
        <detail-list>
          <detail-list-item term="单位网站">{{ enterprise.legalWeb }}</detail-list-item>
          <detail-list-item term="邮政编码">{{ enterprise.legalZipCode }}</detail-list-item>
          <detail-list-item term="电子邮箱">{{ enterprise.legalEmail }}</detail-list-item>
        </detail-list>
        <detail-list>
          <detail-list-item term="企业性质">{{ enterprise.enProperty_dictText }}</detail-list-item>
          <detail-list-item term="是否为小微企业">{{ enterprise.smallScale_dictText }}</detail-list-item>
          <detail-list-item term="是否为监狱企业">{{ enterprise.prisonEnterprise_dictText }}</detail-list-item>
        </detail-list>
        <detail-list>
          <detail-list-item term="是否为中小微企业">{{ enterprise.mediumScale_dictText }}</detail-list-item>
          <detail-list-item term="是否为民营企业">{{ enterprise.personEnterprise_dictText }}</detail-list-item>
        </detail-list>
        <detail-list>
          <detail-list-item term="法人机构行业代码">{{ enterprise.legalIndustry }}</detail-list-item>
          <detail-list-item term="联系人身份证">{{ enterprise.legalContactIdCard }}</detail-list-item>
        </detail-list>
      </a-card>
      <a-card style="margin-top: 24px" :bordered="false" title="附件信息">
        <a-table
          ref="table"
          size="middle"
          bordered
          rowKey="id"
          :columns="columns"
          :dataSource="dataSource"
          :pagination="false"
          :loading="loading"
          @change="handleTableChange"
        >

            <!--<span slot="action" slot-scope="text, record">
              <a @click="handleDownload(record)">下载</a>
            </span>-->
            <span slot="action" slot-scope="text, record">
              <a-space>
                <a @click="handleShowFile(record)">查看</a>
                <a-dropdown>
                  <a class="ant-dropdown-link">更多 <a-icon type="down"/></a>
                  <a-menu slot="overlay">
                    <a-menu-item>
                        <a @click="handleDownload(record)">下载</a>
                    </a-menu-item>
                    <a-menu-item>
                        <a @click="showUploadHistory(record)">历史记录</a>
                    </a-menu-item>
                  </a-menu>
                </a-dropdown>
              </a-space>
            </span>
          <template slot='footer' slot-scope='currentPageData'>
              <span style="color:red;font-weight: bold">注：请根据“首页——办事指南——《福州市电子招投标交易系统注册指南》”要求提交材料</span>
          </template>
        </a-table>
      </a-card>
      <a-card style="margin-top: 24px;padding-bottom: 30px;" :bordered="false" title="审核信息" v-show="!approvalShow">
        <detail-list>
          <detail-list-item term="审核状态">{{ enterprise.approvalStatus_dictText }}</detail-list-item>
          <detail-list-item term="审核时间">{{ enterprise.approvalTime }}</detail-list-item>
<!--          <detail-list-item term="审核者">{{ enterprise.approvalBy }}</detail-list-item>-->
        </detail-list>
        <detail-list>
          <detail-list-item term="审核意见">{{ enterprise.approvalOpinion }}</detail-list-item>
        </detail-list>
      </a-card>
      <a-card style="margin-top: 24px;padding-bottom: 30px;" :bordered="false" title="审核信息" v-show="approvalShow" v-has="'enterprise:check'">
        <a-row style="width: 100%;margin-bottom:20px;">
          <a-col :span="2" class="labelTop" >
            <span>提交时间：</span>
          </a-col>
          <a-col :span="8">
            <span>{{enterprise.submitTime}}</span>
          </a-col>
        </a-row>
        <a-form :form="form">
          <a-row style="width: 100%;">
            <a-col :span="2" class="labelTop" >
              <span><font color="red"> *</font>审核状态：</span>
            </a-col>
            <a-col :span="8">
              <a-form-item>
                <j-dict-select-tag
                  placeholder="请选择审核状态"
                  dictCode="enterprise_approval_status_edit"
                  :triggerChange="true"
                  @change="handleChangeApprovalStatus"
                  v-decorator="['approvalStatus',{rules: [{ required: true, message: '请选择审核状态'}],}]"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row style="width: 100%;margin-top:20px;">
            <a-col :span="2" class="labelTop" >
              <span><font color="red" v-show="!isAgree"> *</font>审核意见：</span>
            </a-col>
            <a-col :span="10">
              <a-form-item>
                <a-textarea style="height: 100px" placeholder="请输入审核意见" v-decorator="['approvalOpinion',{rules: [{ required: !isAgree, message: '请输入审核意见', whitespace: true}], initialValue:enterprise.approvalOpinion}]" />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row style="width: 100%;">
            <a-col :span="2" class="labelTop" >
              <a-button type="primary" @click="submitApproval" :loading="confirmLoading">提交</a-button>
            </a-col>
          </a-row>
        </a-form>
      </a-card>
      <EnterpriseUploadHistory-modal ref="modalForm" @ok="modalFormOk"></EnterpriseUploadHistory-modal>
    </div>
    <div>
      <a-result
        status="success"
        title="企业信息审核成功！"
        sub-title=""
        v-if="result"
      >
      </a-result>
    </div>
  </div>
</template>

<script>
import { mixinDevice } from '@/utils/mixin.js'
import PageLayout from '@/components/page/PageLayout'
import DetailList from '@/components/tools/DetailList'
import {getEnterprise} from '@/api/enterprise'
import {FzisListMixin} from '@/mixins/FzisListMixin'
import { getAction,downloadFile,putAction,httpAction } from '@api/manage'
import EnterpriseUploadHistoryModal from '../enterprise/modules/EnterpriseUploadHistoryModal'





const DetailListItem = DetailList.Item

export default {
  name: "EnterpriseInfo",
  components: {
    PageLayout,
    DetailList,
    DetailListItem,
    EnterpriseUploadHistoryModal
  },
  inject:['closeCurrent'],
  mixins: [mixinDevice,FzisListMixin],
  data () {
    return {
      enterprise: {},
      form: this.$form.createForm(this),
      disableMixinCreated:true,
      editButtonShow:true,
      approvalShow:false,
      confirmLoading:false,
      result: false,
      url: {
        list: "/ebid-ce/file/list",
        delete: "/ebid-ce/file/delete",
        download: "/ebid-ce/file/download",
        minioDownload: "/ebid-ce/file/minioDownload",
        approvalEnterprise: "/ebid-ce/enterprise/approvalEnterprise",
      },
      columns: [
        {
          title: '序号',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: "center",
          customRender: function (t, r, index) {
            return parseInt(index) + 1;
          }
        },
        {
          title: '文件名称',
          align: "center",
          dataIndex: 'fileName'
        },
        {
          title: '文件类型',
          align: "center",
          dataIndex: 'typeZh',
          customRender: function(t, r, index) {
            if(r.type==="basicAccount"||r.type==="businessLicense")
            {
              return <div>{t}<span style="color: red;font-weight: bold">(加盖单位公章)</span></div>
            }else
            {
              return t;
            }

          }
        },
        {
          title: '上传时间',
          align: "center",
          dataIndex: 'createTime'
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: "center",
          scopedSlots: {customRender: 'action'},
        }
      ],
      isAgree:false,
    }
  },
  created: function () {
      this.initEnterprise();
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        if(this.$route.name == 'ienterprise-enterpriseInfo'){
          this.initEnterprise();
        }
      }
    }
  },
  methods: {
    initEnterprise(){
      let s = this;
      let enterpriseParam = {};
      if(this.$route.params.id){
        enterpriseParam.id = this.$route.params.id;
        if(this.$route.params.isApproval==1){
          this.editButtonShow = false;
          this.approvalShow=true;
        }else if(this.$route.params.isApproval==0){
          this.editButtonShow = false;
          this.approvalShow=false;
        }
      }
      getEnterprise(enterpriseParam).then((res) => {
        if (res.success) {
          s.enterprise = res.result;
          console.log("查询成功",res);
          this.queryParam.enterpriseId=s.enterprise.id;
          this.queryParam.type="businessLicense,enterpriseOtherFile,basicAccount";
          console.log("this.queryParam.enterpriseId=",this.queryParam.enterpriseId);
          this.loadData();
        } else {
          if(res.message){
            this.$message.warning(res.message)
          }else{
            this.$message.warning(res)
          }
        }
      })
    },
    ebidEnterprise(){
      this.$router.push({ name: 'ienterprise-enterpriseEdit' })
    },
    handleChange(info) {
      if (info.file.status === 'done') {
        if (info.file.response.success) {
          this.loadData()
          this.$message.success(`${info.file.name} 上传成功!`);
        } else {
          this.$message.error(`${info.file.response.message}`);
        }
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file.response.message}`);
      }
    },
    handleShowFile(record){
      let that = this;
      getAction(that.url.minioDownload,{id: record.id}).then(res => {
        if(res.success) {
          window.open(res.result,'_blank');
        }else{
          that.$message.error(res.message);
        }
      });
    },
    handleDownload(rec) {
      let that = this;
      getAction(that.url.minioDownload,{id: rec.id}).then(res => {
        if(res.success) {
          console.log(res.result);
          downloadFile(res.result , rec.fileName);
        }else{
          that.$message.error(res.message);
        }
      });
    },
    showUploadHistory(record){
      this.$refs.modalForm.show(record);
      this.$refs.modalForm.title = "上传历史-" + record.typeZh;
    },
    submitApproval(){
      const that = this;
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          let formData = Object.assign({}, values);
          formData.id=that.enterprise.id;
          that.$confirm({
            title: "确认提交",
            content: "是否确认提交审核信息?",
            onOk: function () {
              that.confirmLoading = true;
              httpAction(that.url.approvalEnterprise,formData,'post').then((res)=>{
                console.log(res);
                if(res.success){
                  //that.$message.success(res.message);
                  console.log("提交成功！" + res);
                  //that.result = true;
                  that.$message.success('企业信息审核完毕!', 1,function(){
                    that.closeCurrent();
                  });
                }else{
                  that.$message.warning(res.message,3);
                }
              }).finally(() => {
                that.confirmLoading = false;
              });
            }
          });
        }
      });
    },
    handleChangeApprovalStatus(value){
      if (value == 3){
        this.isAgree = true
      }else{
        this.isAgree = false
      }
    }
  },
  filters: {

  }
}
</script>

<style lang="less" scoped>

.detail-layout {
  margin-left: 44px;
}
.text {
  color: rgba(0, 0, 0, .45);
}

.heading {
  color: rgba(0, 0, 0, .85);
  font-size: 20px;
}

.no-data {
  color: rgba(0, 0, 0, .25);
  text-align: center;
  line-height: 64px;
  font-size: 16px;

  i {
    font-size: 24px;
    margin-right: 16px;
    position: relative;
    top: 3px;
  }
}

.mobile {
  .detail-layout {
    margin-left: unset;
  }
  .text {

  }
  .status-list {
    text-align: left;
  }
}
</style>